import { TransportOperatorInterface } from '../transportOperators/types';
import { TransportCardInterface } from '../transportCards/types';
import { DenyListInterface } from '../denylist/types';
import { SchoolInterface } from '../schools/types';

/*
 * Action Types
 */
export enum UsersTypes {
  LOGIN_REQUEST = '@users/LOGIN_REQUEST',
  LOGIN_SUCCESS = '@users/LOGIN_SUCCESS',
  LOGIN_FAILURE = '@users/LOGIN_FAILURE',

  ENROLL_MFA_REQUEST = '@users/ENROLL_MFA_REQUEST',
  ENROLL_MFA_SUCCESS = '@users/ENROLL_MFA_SUCCESS',
  ENROLL_MFA_FAILURE = '@users/ENROLL_MFA_FAILURE',

  VERIFY_MFA_ENROLL_REQUEST = '@users/VERIFY_MFA_ENROLL_REQUEST',
  VERIFY_MFA_ENROLL_SUCCESS = '@users/VERIFY_MFA_ENROLL_SUCCESS',
  VERIFY_MFA_ENROLL_FAILURE = '@users/VERIFY_MFA_ENROLL_FAILURE',

  UNENROLL_MFA_REQUEST = '@users/UNENROLL_MFA_REQUEST',
  UNENROLL_MFA_SUCCESS = '@users/UNENROLL_MFA_SUCCESS',
  UNENROLL_MFA_FAILURE = '@users/UNENROLL_MFA_FAILURE',

  VERIFY_MFA_REQUEST = '@users/VERIFY_MFA_REQUEST',
  VERIFY_MFA_SUCCESS = '@users/VERIFY_MFA_SUCCESS',
  VERIFY_MFA_FAILURE = '@users/VERIFY_MFA_FAILURE',

  SET_MFA_RESOLVER = '@users/SET_MFA_RESOLVER',

  LOGOUT_REQUEST = '@users/LOGOUT_REQUEST',
  LOGOUT_SUCCESS = '@users/LOGOUT_SUCCESS',
  LOGOUT_FAILURE = '@users/LOGOUT_FAILURE',

  SET_LOGGED_USER_DATA = '@users/SET_LOGGED_USER_DATA',

  FORGOT_PASSWORD_REQUEST = '@users/FORGOT_PASSWORD_REQUEST',
  FORGOT_PASSWORD_SUCCESS = '@users/FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_FAILURE = '@users/FORGOT_PASSWORD_FAILURE',

  CREATE_PASSWORD_REQUEST = '@users/CREATE_PASSWORD_REQUEST',
  CREATE_PASSWORD_SUCCESS = '@users/CREATE_PASSWORD_SUCCESS',
  CREATE_PASSWORD_FAILURE = '@users/CREATE_PASSWORD_FAILURE',

  RESET_PASSWORD_VERIFY_REQUEST = '@users/RESET_PASSWORD_VERIFY_REQUEST',
  RESET_PASSWORD_VERIFY_SUCCESS = '@users/RESET_PASSWORD_VERIFY_SUCCESS',
  RESET_PASSWORD_VERIFY_FAILURE = '@users/RESET_PASSWORD_VERIFY_FAILURE',

  RESET_PASSWORD_REQUEST = '@users/RESET_PASSWORD_REQUEST',
  RESET_PASSWORD_SUCCESS = '@users/RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAILURE = '@users/RESET_PASSWORD_FAILURE',

  // WEB USERS
  LIST_WEB_USERS_REQUEST = '@users/LIST_WEB_USERS_REQUEST',
  LIST_WEB_USERS_SUCCESS = '@users/LIST_WEB_USERS_SUCCESS',
  LIST_WEB_USERS_FAILURE = '@users/LIST_WEB_USERS_FAILURE',

  LIST_FROM_MODULES_WEB_USERS_REQUEST = '@users/LIST_FROM_MODULES_WEB_USERS_REQUEST',
  LIST_FROM_MODULES_WEB_USERS_SUCCESS = '@users/LIST_FROM_MODULES_WEB_USERS_SUCCESS',
  LIST_FROM_MODULES_WEB_USERS_FAILURE = '@users/LIST_FROM_MODULES_WEB_USERS_FAILURE',

  FILTER_WEB_USERS_REQUEST = '@users/FILTER_WEB_USERS_REQUEST',
  FILTER_WEB_USERS_SUCCESS = '@users/FILTER_WEB_USERS_SUCCESS',
  FILTER_WEB_USERS_FAILURE = '@users/FILTER_WEB_USERS_FAILURE',

  GET_WEB_USER_REQUEST = '@users/GET_WEB_USER_REQUEST',
  GET_WEB_USER_SUCCESS = '@users/GET_WEB_USER_SUCCESS',
  GET_WEB_USER_FAILURE = '@users/GET_WEB_USER_FAILURE',

  CREATE_WEB_USER_REQUEST = '@users/CREATE_WEB_USER_REQUEST',
  CREATE_WEB_USER_SUCCESS = '@users/CREATE_WEB_USER_SUCCESS',
  CREATE_WEB_USER_FAILURE = '@users/CREATE_WEB_USER_FAILURE',

  UPDATE_WEB_USER_REQUEST = '@users/UPDATE_WEB_USER_REQUEST',
  UPDATE_WEB_USER_SUCCESS = '@users/UPDATE_WEB_USER_SUCCESS',
  UPDATE_WEB_USER_FAILURE = '@users/UPDATE_WEB_USER_FAILURE',

  UPDATE_WEB_USER_EMAIL_REQUEST = '@users/UPDATE_WEB_USER_EMAIL_REQUEST',
  UPDATE_WEB_USER_EMAIL_SUCCESS = '@users/UPDATE_WEB_USER_EMAIL_SUCCESS',
  UPDATE_WEB_USER_EMAIL_FAILURE = '@users/UPDATE_WEB_USER_EMAIL_FAILURE',

  DELETE_WEB_USER_REQUEST = '@users/DELETE_WEB_USER_REQUEST',
  DELETE_WEB_USER_SUCCESS = '@users/DELETE_WEB_USER_SUCCESS',
  DELETE_WEB_USER_FAILURE = '@users/DELETE_WEB_USER_FAILURE',

  // APP USERS
  LIST_APP_USERS_REQUEST = '@users/LIST_APP_USERS_REQUEST',
  LIST_APP_USERS_SUCCESS = '@users/LIST_APP_USERS_SUCCESS',
  LIST_APP_USERS_FAILURE = '@users/LIST_APP_USERS_FAILURE',

  GET_APP_USER_REQUEST = '@users/GET_APP_USER_REQUEST',
  GET_APP_USER_SUCCESS = '@users/GET_APP_USER_SUCCESS',
  GET_APP_USER_FAILURE = '@users/GET_APP_USER_FAILURE',

  FILTER_APP_USERS_REQUEST = '@users/FILTER_APP_USERS_REQUEST',
  FILTER_APP_USERS_SUCCESS = '@users/FILTER_APP_USERS_SUCCESS',
  FILTER_APP_USERS_FAILURE = '@users/FILTER_APP_USERS_FAILURE',

  GET_APP_USER_FROM_DOCUMENT_REQUEST = '@users/GET_APP_USER_FROM_DOCUMENT_REQUEST',
  GET_APP_USER_FROM_DOCUMENT_SUCCESS = '@users/GET_APP_USER_FROM_DOCUMENT_SUCCESS',
  GET_APP_USER_FROM_DOCUMENT_FAILURE = '@users/GET_APP_USER_FROM_DOCUMENT_FAILURE',

  // APP USERS MERGE
  LIST_APP_USERS_MERGE_REQUEST = '@users/LIST_APP_USERS_MERGE_REQUEST',
  LIST_APP_USERS_MERGE_SUCCESS = '@users/LIST_APP_USERS_MERGE_SUCCESS',
  LIST_APP_USERS_MERGE_FAILURE = '@users/LIST_APP_USERS_MERGE_FAILURE',

  FILTER_APP_USERS_MERGE_REQUEST = '@users/FILTER_APP_USERS_MERGE_REQUEST',
  FILTER_APP_USERS_MERGE_SUCCESS = '@users/FILTER_APP_USERS_MERGE_SUCCESS',
  FILTER_APP_USERS_MERGE_FAILURE = '@users/FILTER_APP_USERS_MERGE_FAILURE',

  APP_USER_MERGE_REQUEST = '@users/APP_USER_MERGE_REQUEST',
  APP_USER_MERGE_SUCCESS = '@users/APP_USER_MERGE_SUCCESS',
  APP_USER_MERGE_FAILURE = '@users/APP_USER_MERGE_FAILURE',

  GET_APP_USER_MERGE_REQUEST = '@users/GET_APP_USER_MERGE_REQUEST',
  GET_APP_USER_MERGE_SUCCESS = '@users/GET_APP_USER_MERGE_SUCCESS',
  GET_APP_USER_MERGE_FAILURE = '@users/GET_APP_USER_MERGE_FAILURE',

  SET_APP_USER_MERGE_ERROR = '@users/SET_APP_USER_MERGE_ERROR',

  // Set Selected Search User
  SET_SELECTED_SEARCH_USER = '@users/SET_SELECTED_SEARCH_USER',

  // Get User in Company By document
  GET_APP_USER_IN_COMPANY_BY_DOCUMENT_REQUEST = '@users/GET_APP_USER_IN_COMPANY_BY_DOCUMENT_REQUEST',
  GET_APP_USER_IN_COMPANY_BY_DOCUMENT_SUCCESS = '@users/GET_APP_USER_IN_COMPANY_BY_DOCUMENT_SUCCESS',
  GET_APP_USER_IN_COMPANY_BY_DOCUMENT_FAILURE = '@users/GET_APP_USER_IN_COMPANY_BY_DOCUMENT_FAILURE',

  CREATE_APP_USER_REQUEST = '@users/CREATE_APP_USER_REQUEST',
  CREATE_APP_USER_SUCCESS = '@users/CREATE_APP_USER_SUCCESS',
  CREATE_APP_USER_FAILURE = '@users/CREATE_APP_USER_FAILURE',

  UPDATE_APP_USER_REQUEST = '@users/UPDATE_APP_USER_REQUEST',
  UPDATE_APP_USER_SUCCESS = '@users/UPDATE_APP_USER_SUCCESS',
  UPDATE_APP_USER_FAILURE = '@users/UPDATE_APP_USER_FAILURE',

  CREATE_APP_USER_ADDRESS_REQUEST = '@users/CREATE_APP_USER_ADDRESS_REQUEST',
  CREATE_APP_USER_ADDRESS_SUCCESS = '@users/CREATE_APP_USER_ADDRESS_SUCCESS',
  CREATE_APP_USER_ADDRESS_FAILURE = '@users/CREATE_APP_USER_ADDRESS_FAILURE',

  DELETE_APP_USER_ADDRESS_REQUEST = '@users/DELETE_APP_USER_ADDRESS_REQUEST',
  DELETE_APP_USER_ADDRESS_SUCCESS = '@users/DELETE_APP_USER_ADDRESS_SUCCESS',
  DELETE_APP_USER_ADDRESS_FAILURE = '@users/DELETE_APP_USER_ADDRESS_FAILURE',

  DELETE_APP_USER_REQUEST = '@users/DELETE_APP_USER_REQUEST',
  DELETE_APP_USER_SUCCESS = '@users/DELETE_APP_USER_SUCCESS',
  DELETE_APP_USER_FAILURE = '@users/DELETE_APP_USER_FAILURE',

  USER_PROFILE_TOGGLE_REQUEST = '@users/USER_PROFILE_TOGGLE_REQUEST',
  USER_PROFILE_TOGGLE_SUCCESS = '@users/USER_PROFILE_TOGGLE_SUCCESS',
  USER_PROFILE_TOGGLE_FAILURE = '@users/USER_PROFILE_TOGGLE_FAILURE',

  USER_PROFILE_RENEW_REQUEST = '@users/USER_PROFILE_RENEW_REQUEST',
  USER_PROFILE_RENEW_SUCCESS = '@users/USER_PROFILE_RENEW_SUCCESS',
  USER_PROFILE_RENEW_FAILURE = '@users/USER_PROFILE_RENEW_FAILURE',

  CREATE_APP_USER_DOCUMENT_REQUEST = '@users/CREATE_APP_USER_DOCUMENT_REQUEST',
  CREATE_APP_USER_DOCUMENT_SUCCESS = '@users/CREATE_APP_USER_DOCUMENT_SUCCESS',
  CREATE_APP_USER_DOCUMENT_FAILURE = '@users/CREATE_APP_USER_DOCUMENT_FAILURE',

  UPDATE_APP_USER_DOCUMENT_REQUEST = '@users/UPDATE_APP_USER_DOCUMENT_REQUEST',
  UPDATE_APP_USER_DOCUMENT_SUCCESS = '@users/UPDATE_APP_USER_DOCUMENT_SUCCESS',
  UPDATE_APP_USER_DOCUMENT_FAILURE = '@users/UPDATE_APP_USER_DOCUMENT_FAILURE',

  DELETE_APP_USER_DOCUMENT_REQUEST = '@users/DELETE_APP_USER_DOCUMENT_REQUEST',
  DELETE_APP_USER_DOCUMENT_SUCCESS = '@users/DELETE_APP_USER_DOCUMENT_SUCCESS',
  DELETE_APP_USER_DOCUMENT_FAILURE = '@users/DELETE_APP_USER_DOCUMENT_FAILURE',

  CREATE_APP_USER_COMMENT_REQUEST = '@users/CREATE_APP_USER_COMMENT_REQUEST',
  CREATE_APP_USER_COMMENT_SUCCESS = '@users/CREATE_APP_USER_COMMENT_SUCCESS',
  CREATE_APP_USER_COMMENT_FAILURE = '@users/CREATE_APP_USER_COMMENT_FAILURE',

  UPDATE_APP_USER_COMMENT_REQUEST = '@users/UPDATE_APP_USER_COMMENT_REQUEST',
  UPDATE_APP_USER_COMMENT_SUCCESS = '@users/UPDATE_APP_USER_COMMENT_SUCCESS',
  UPDATE_APP_USER_COMMENT_FAILURE = '@users/UPDATE_APP_USER_COMMENT_FAILURE',

  DELETE_APP_USER_COMMENT_REQUEST = '@users/DELETE_APP_USER_COMMENT_REQUEST',
  DELETE_APP_USER_COMMENT_SUCCESS = '@users/DELETE_APP_USER_COMMENT_SUCCESS',
  DELETE_APP_USER_COMMENT_FAILURE = '@users/DELETE_APP_USER_COMMENT_FAILURE',

  GET_APP_USER_SETTINGS_REQUEST = '@users/GET_APP_USER_SETTINGS_REQUEST',
  GET_APP_USER_SETTINGS_SUCCESS = '@users/GET_APP_USER_SETTINGS_SUCCESS',
  GET_APP_USER_SETTINGS_FAILURE = '@users/GET_APP_USER_SETTINGS_FAILURE',

  UPDATE_APP_USER_SETTINGS_REQUEST = '@users/UPDATE_APP_USER_SETTINGS_REQUEST',
  UPDATE_APP_USER_SETTINGS_SUCCESS = '@users/UPDATE_APP_USER_SETTINGS_SUCCESS',
  UPDATE_APP_USER_SETTINGS_FAILURE = '@users/UPDATE_APP_USER_SETTINGS_FAILURE',

  DELETE_APP_USER_SETTINGS_REQUEST = '@users/DELETE_APP_USER_SETTINGS_REQUEST',
  DELETE_APP_USER_SETTINGS_SUCCESS = '@users/DELETE_APP_USER_SETTINGS_SUCCESS',
  DELETE_APP_USER_SETTINGS_FAILURE = '@users/DELETE_APP_USER_SETTINGS_FAILURE',

  APP_USER_SEND_USER_TRANSACTION_BY_EMAIL_REQUEST = '@users/APP_USER_SEND_USER_TRANSACTION_BY_EMAIL_REQUEST',
  APP_USER_SEND_USER_TRANSACTION_BY_EMAIL_SUCCESS = '@users/APP_USER_SEND_USER_TRANSACTION_BY_EMAIL_SUCCESS',
  APP_USER_SEND_USER_TRANSACTION_BY_EMAIL_FAILURE = '@users/APP_USER_SEND_USER_TRANSACTION_BY_EMAIL_FAILURE',

  CREATE_SUPERVISOR_PROFILE_REQUEST = '@users/CREATE_SUPERVISOR_PROFILE_REQUEST',
  CREATE_SUPERVISOR_PROFILE_SUCCESS = '@users/CREATE_SUPERVISOR_PROFILE_SUCCESS',
  CREATE_SUPERVISOR_PROFILE_FAILURE = '@users/CREATE_SUPERVISOR_PROFILE_FAILURE',

  APP_USER_CHECK_FACIAL_LIST_REQUEST = '@users/APP_USER_CHECK_FACIAL_LIST_REQUEST',
  APP_USER_CHECK_FACIAL_LIST_SUCCESS = '@users/APP_USER_CHECK_FACIAL_LIST_SUCCESS',
  APP_USER_CHECK_FACIAL_LIST_FAILURE = '@users/APP_USER_CHECK_FACIAL_LIST_FAILURE',

  APP_USER_FACIAL_REGISTER_REQUEST = '@users/APP_USER_FACIAL_REGISTER_REQUEST',
  APP_USER_FACIAL_REGISTER_SUCCESS = '@users/APP_USER_FACIAL_REGISTER_SUCCESS',
  APP_USER_FACIAL_REGISTER_FAILURE = '@users/APP_USER_FACIAL_REGISTER_FAILURE',

  DELETE_CHARGE_REQUEST_REQUEST = '@users/DELETE_CHARGE_REQUEST_REQUEST',
  DELETE_CHARGE_REQUEST_SUCCESS = '@users/DELETE_CHARGE_REQUEST_SUCCESS',
  DELETE_CHARGE_REQUEST_FAILURE = '@users/DELETE_CHARGE_REQUEST_FAILURE',
}

/*
 * Data types
 */
export interface UserFirebase {
  displayName?: string;
  email?: string;
  emailVerified?: boolean;
  isAnonymous?: boolean;
  metadata?: object;
  phoneNumber?: string;
  photoURL?: string;
  providerData?: any;
  providerId?: any;
  refreshToken?: string;
  tenantId?: string;
  uid?: string;
  mfaEnabled?: boolean;
}

export interface SupervisorProfileOperationsInterface {
  id: string;
  type: string;
  createdAt: string;
  updatedAt: string;
  profileId: string;
  supervisorId: string;
  transportOperatorId: string;
  Profile: ProfilesInterface;
}

export interface WebUser {
  id: string;
  name: string;
  email: string;
  photoUrl: string;
  createdAt: string;
  updatedAt: string;
  transportOperatorId: string;
  TransportOperators: TransportOperatorInterface[];
  isUpdate: boolean;
  SupervisorProfileOperations?: SupervisorProfileOperationsInterface[];
}

export interface WebUserFromModules {
  id: string;
  name: string;
  email: string;
  photoUrl: string;
  createdAt: string;
  updatedAt: string;
  transportOperatorId: string;
  SupervisorOperator: {
    id: string;
    modules: string;
    levels: string;
    supervisorId: string;
    operatorId: string;
    createdAt?: string | null;
    updatedAt?: string | null;
  };
  isUpdate: boolean;
}

export interface UserDevicesInterface {
  id: string;
  type: string;
  value: string;
  status: number;
  lastUsedAt: string | null;
  createdAt: string;
  updatedAt: string;
  userId: string;
}

export interface UserProfileInterface {
  id: string;
  userId: string;
  profileId: string;
  status: number;
  createdAt: string;
  expiresAt: string;
  updatedAt: string;
}

export interface ProfilesInterface {
  id: string;
  name: string;
  data: string;
  order: number;
  expires: string;
  createdAt: string;
  transportOperatorId: string;
  updatedAt: string;
  UserProfile: UserProfileInterface;
}

export interface UserProfileRequestHistoriesInterface {
  id: string;
  fromStatus: number;
  toStatus: number;
  message: string;
  createdAt: string;
  updatedAt: string;
  userProfileRequestId: string;
}

export interface CreditsByFareInterface {
  fareId: string;
  quantity: number;
  timing: number;
}

export interface UserProfilesInterface {
  id: string;
  status: number;
  expiresAt: string;
  blockedUntil: number | null;
  createdAt: string;
  updatedAt: string;
  userId: string;
  profileId: string;
  schoolId: string | null;
  Profile: {
    id: string;
    order: number;
    expires: number | string;
    name: string;
    status: number;
    data: string;
    facial: boolean;
    description: string;
    autoApprove: boolean;
    walletChargeValue: number;
    walletChargeTiming: number;
    walletChargeTimingType?: number;
    allowCreditsByFare: CreditsByFareInterface | null;
    schoolOnly: boolean;
    createdAt: string;
    updatedAt: string;
  };
  UserProfileRequest: {
    id: string;
    status: number;
    type: number;
    data: string;
    createdAt: string;
    updatedAt: string;
    userProfileId: string;
    UserProfileRequestHistories: Array<UserProfileRequestHistoriesInterface>;
  };
  School: string | null;
}

export interface UserDocumentsInterface {
  id: string;
  userId: string;
  UserProfiles: any[];
  createdAt: string;
  data: string | null;
  document: string;
  photoUrl: string | null;
  type: number;
  updatedAt: string;
}

export interface Balance {
  currentBalance: number;
  pendingBalance: number;
}

export interface AppUserComment {
  id?: string;
  comment: string;
  attachmentPhoto: string;
  userId: string;
  createdAt?: string;
  TransportSupervisor: AppUserCommentSupervisor;
}

export interface AppUserSettingsInterface {
  id: string;
  operationMethods: string[] | null;
  transportOperatorId: string;
  createdAt: string;
  updatedAt: string;
}

export interface LinkUserToCompanyInterface {
  id: string;
  name: string;
  cnpj: string;
  phone: string;
  email: string;
  status: number;
  createdAt: string;
  updatedAt: string;
  CompanyUser: any;
}

export interface ProductTransactionsInterface {
  id: string;
  value: number;
  exception: string | null;
  description: string;
  createdAt: string;
  updatedAt: string;
  productId: string;
  userId: string;
  Product: {
    id: string;
    title: string;
    type: string;
    availability: string;
    status: number;
    data: string;
    picture: string;
    createdAt: string;
    updatedAt: string;
  };
}

export interface AppUserInvalidEntryPayload {
  cardId?: string;
  tokenId?: string;
  cardNumber?: string;
  error?: string;
  errors?: string[];
  denylist?: number;
  lat?: string;
  lng?: string;
  lineSectionId?: string;
  result?: string;
  type?: string;
  usedAt?: string;
  dbdId?: string;
  tripId?: string;
}

export interface AppUserDbdInvalidEntry {
  id: string;
  payload: string;
  result?: string;
  type?: string;
  cardId?: string;
  tokenId?: string;
  dbdId?: string;
  usedAt?: string;
  tripId?: string;
  createdAt?: string;
  updatedAt?: string;
  Dbd?: {
    serial?: string;
  };
  Trip?: {
    id?: string;
    Car?: {
      prefix?: string;
      license?: string;
    };
    LineSection?: {
      shortId?: string;
      name?: string;
      Line?: {
        name?: string;
        prefix?: string;
      };
    };
  };
}

export interface AppUser {
  id: string;
  shortId: string;
  name: string;
  nickname: string | null;
  profile?: string;
  email: string;
  document: string;
  phone: string;
  obs: string;
  sex: string;
  createdAt: string;
  expires: string;
  updatedAt: string;
  deleted: boolean;
  photoUrl: string | null;
  birthplace: string | null;
  birthdate: string | null;
  facialStatus?: boolean;
  TransportCards?: TransportCardInterface[];
  Denylists?: DenyListInterface[];
  Balance?: Balance;
  Devices?: UserDevicesInterface[];
  Companies?: LinkUserToCompanyInterface[];
  Schools?: SchoolInterface[];
  Profiles: ProfilesInterface[];
  UserProfiles: UserProfilesInterface[];
  UserDocuments: UserDocumentsInterface[];
  UserComments: AppUserComment[];
  DbdInvalidEntries?: AppUserDbdInvalidEntry[];
  Addresses?: any;
  ProductTransactions: ProductTransactionsInterface[];
  CreditCards?: {
    id: string | null;
    holder: string;
    number: string;
    cvv: string;
    expiration: string;
    document: string;
    brand: string;
  }[];
}

export interface AppUserDocument {
  userId: string;
  document: string;
  photoUrl?: string | null;
  type?: number;
}

export interface AppUserCommentSupervisor {
  name: string;
}

// Type for AUTH.MODULOS_MANEGEMENT
export interface SubModules {
  key: string;
  value: string;
}
export interface ModulesProps {
  value: string;
  key: string;
  modules: SubModules[];
}

export interface AppUserCheckFacialListInterface {
  id: string;
  title: string;
  registered: boolean;
}

export interface TotpSecret {
  qrCodeUrl: string;
  secretKey: string;
}

export interface UserState {
  currentUser: any;
  mfaResolver: any;
  totpSecret: TotpSecret | null;
  isEnrolling: boolean;
  isVerifying: boolean;
  error: string | null;
}

/*
 * State type
 */
export interface UsersState {
  readonly firebaseData: UserFirebase;
  readonly webUsersList: WebUser[];
  readonly webUsersListFromModules: WebUserFromModules[];
  readonly webUserData: WebUser;
  readonly appUsersList: AppUser[];
  readonly appUsersListFull: AppUser[];
  readonly appUsersMergeList: AppUser[];
  readonly selectedSearchUser: AppUser[];
  readonly appUserData: AppUser;
  readonly appUserMergeData: AppUser;
  readonly appUserInCompanyData: AppUser;
  readonly appUserDocumentData: AppUserDocument;
  readonly appUserCommentData: AppUserComment;
  readonly appUserSettingsData: AppUserSettingsInterface;
  readonly totalCount: number;
  readonly totalCountMerge: number;
  readonly mergeAccountsError: boolean;
  readonly appUserCheckFacialList: AppUserCheckFacialListInterface[];
  readonly mfaEnabled?: boolean;
  readonly mfaResolver?: any;
  readonly mfaPending?: boolean;
  readonly mfaError?: string;
  readonly currentUser: any;
  readonly totpSecret: any;
  readonly isEnrolling: boolean;
  readonly isVerifying: boolean;
  readonly isVerifyingEnroll: boolean;
  readonly loading: boolean;
  readonly created: boolean;
  readonly error: boolean;
  readonly email: string;
}
